// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"8c02c973","325":"66bfb210","554":"123bbe7c","686":"66bfb210","752":"0bd84634","772":"151f6111","875":"4a2bae31"}[chunkId] + ".chunk.css";
};